import appModuleRegistry from "components/appModules/appModuleRegistry";
import { LocalStorage } from "components/appModules/LocalStorage";
import { initCompoments } from "components/componentFactory";
import i18n from "components/i18n/i18n";
import { FocusManager } from "components/pages/focusManager";
import { Router } from "components/router/router";
import sislogUserGlobals from "components/UserGlobals";
import $ from "jquery";
import "styles/main.scss";
import "vendor";

export class AppStartupStatus {
    private started = false;
    private callback: any;
    public setStarted = () => {
        this.started = true;
        if (this.callback != null) {
            this.callback();
        }
    }
    public run = (callback: () => void) => {
        if (this.started) {
            callback();
        } else {
            this.callback = callback;
        }
    }
}

$(async () => {
    let appStartupStatus = new AppStartupStatus();
    let appConfig = window["sislog6AppConfig"];
    await Promise.all([
        i18n.init(
            appConfig.languages,
            i18nInitCallbackFactory(appStartupStatus)),
        initCompoments(),
        FocusManager.instance()]);
});

let i18nInitCallbackFactory = (appStartupStatus: AppStartupStatus) => {
    return () => {
        let appConfig = window["sislog6AppConfig"];
        if (appConfig.languages != null) {
            i18n.setLanguages(appConfig.languages);
        }
        sislogUserGlobals.language = i18n.instance.language;
        LocalStorage.init(appConfig.prefix);
        for (let module of appConfig.modules) {
            appModuleRegistry.register(module, appStartupStatus);
        }
        Router.getInstance(appStartupStatus).registerNotFound();
    };
};
